import SEOHead from '@/components/SEOHead';
import TrocHeroV2 from '@/components/marketing/troc/v2/TrocHeroV2';
import TrocProblemV2 from '@/components/marketing/troc/v2/TrocProblemV2';
import TrocHowItWorksV2 from '@/components/marketing/troc/v2/TrocHowItWorksV2';
import TrocPillarsV2 from '@/components/marketing/troc/v2/TrocPillarsV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

export default function Troc() {
  return (
    <>
      <SEOHead
        title="Troc & reprise — Accepte un article en paiement | Velko"
        description="Le module troc/reprise de Velko : accepte un ancien article en paiement, cumule plusieurs reprises, calcule l'appoint dans les deux sens (rendu monnaie auto) et remets l'occasion en stock. Sur ta caisse, même hors ligne."
        path="/troc"
        ogImage="/brand/og/og-troc.png"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Troc & reprise', path: '/troc' },
        ]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'Velko — Troc & reprise',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web, Windows, macOS, Linux, Android',
          description:
            "Module de troc et reprise pour point de vente : accepter un article en paiement, reprises multiples, calcul d'appoint et rendu monnaie automatiques, remise en stock de l'occasion.",
          offers: {
            '@type': 'Offer',
            priceCurrency: 'XOF',
            price: '0',
          },
        }}
      />

      <TrocHeroV2 />
      <TrocProblemV2 />
      <TrocHowItWorksV2 />
      <TrocPillarsV2 />
      <FinalCtaSection
        eyebrow="Débloque la vente"
        title="Plus de reprises."
        highlight="Zéro erreur de caisse."
        subtitle="Active le troc et accepte les anciens articles en paiement sans calculer quoi que ce soit. L'appoint, le rendu monnaie et le restock — Velko s'en charge."
        primaryLabel="Commencer gratuitement"
        primaryTo="/register"
        secondaryLabel="Voir les tarifs"
        secondaryTo="/tarifs"
        guarantees={['Module inclus', 'Reprises multiples', 'Hors ligne natif', 'Support FR']}
      />
    </>
  );
}
